import { SocialMedia } from '@baseball-near-you/common';
import {
  Facebook,
  Globe2,
  Instagram,
  type LucideIcon,
  Phone,
  Twitter,
  Youtube,
} from 'lucide-react';

export const SocialIconMapping: Record<SocialMedia, LucideIcon | null> = {
  [SocialMedia.TikTok]: Phone,
  [SocialMedia.Facebook]: Facebook,
  [SocialMedia.Instagram]: Instagram,
  [SocialMedia.Twitter]: Twitter,
  [SocialMedia.Website]: Globe2,
  [SocialMedia.PerfectGame]: null,
  [SocialMedia.YouTube]: Youtube,
};
